/** O quadro como a API o devolve. Mora fora da tela porque o modal também o recebe. */
import type { Membro } from '../../api/tipos';

export interface Tag {
  id: number;
  nome: string;
  cor: string;
}

export interface Card {
  id: number;
  nome: string;
  /** O que é o card, em texto livre. Nulo enquanto ninguém escreveu. */
  descricao?: string | null;
  concluida: boolean;
  ordem: number;
  responsaveis: number[];
  tags: Tag[];
  checklist: { feitos: number; total: number };
  comentarios: number;
  /**
   * Tem algo que <b>quem está olhando</b> ainda não viu.
   *
   * <p>Duas perguntas numa: nunca abriu este card, ou abriu e há comentário mais novo
   * que a última visita. As duas acendem a mesma bolinha, porque as duas significam a
   * mesma coisa para quem varre o quadro — <i>tem coisa aqui que eu não li</i>.
   *
   * <p>É por pessoa: o mesmo card fica aceso para quem não abriu e apagado para quem
   * já leu. E o que você mesmo comenta não acende a sua — é a regra que as
   * notificações já seguem.
   */
  naoVisto: boolean;
}

export interface Coluna {
  id: number;
  nome: string;
  cor: string | null;
  ordem: number;
  cards: Card[];
}

/**
 * Quanto do quadro já foi feito.
 *
 * <p>Vem do servidor calculado. A tela poderia somar os cards que ela já tem na mão, mas
 * a barra da sidebar não tem o quadro — e duas contas para a mesma medida divergem, é só
 * questão de quando. Foi a lição do progresso do mundo, que já disse três números
 * diferentes para a mesma pergunta.
 */
export interface ProgressoDoQuadro {
  total: number;
  concluidos: number;
  pct: number;
}

export interface Quadro {
  id: number;
  nome: string;
  colunas: Coluna[];
  membros: Membro[];
  /** O catálogo de tags do quadro — criadas uma vez, aplicadas em quantos cards quiser. */
  tags: Tag[];
  progresso: ProgressoDoQuadro;
}

export const SLUG = 'mistik-island';
export const CHAVE_QUADRO = ['quadro', SLUG] as const;
